import React, { Component } from 'react'
import Icon from '../Icon';

import '../../../assets/sass/global/sections/player-ability-table.scss';


export default class PlayerAbilityTable extends Component {
    render() {
        return (
            <div className="player-ability-table">
                {this.renderHeader()}
                <table className="table player-ability-table--table">
                    {this.renderTableHeader()}
                    {this.renderTableBody()}
                </table>
            </div>
        )
    }

    renderHeader() {
        const { icon, title } = this.props;

        return (
            <div className="player-ability-table--header">
                <Icon className="player-ability-table--header--icon" svg={icon} />
                <h5 className="player-ability-table--header--title">{title}</h5>
            </div>
        )
    }

    renderTableHeader() {
        return (
            <thead>
                <tr>
                    <th>Attribute</th>
                    <th>Comments</th>
                    <th>Score</th>
                </tr>
            </thead>
        )
    }

    renderTableBody() {
        const { items } = this.props;

        return (
            <tbody>
                {items.map(({ title, description, value }) => (
                    <tr>
                        <td className="title">{title}</td>
                        <td className="description">{description}</td>
                        <td className="value">{value}</td>
                    </tr>
                ))}
            </tbody>
        )
    }
}
